import { apolloClient } from '../apolloClient'
import { setGlobal } from '../../global/useGlobal'
import { GET_AVAILABLE_VISITATION_RAFFLES } from './queries/GET_AVAILABLE_VISITATION_RAFFLES'
import { EventTypes } from '../../screens/AppointmentsScreen/constants'

export const getAvailableVisitationRaffles = async () => {
  try {
    const response = await apolloClient.query({
      query: GET_AVAILABLE_VISITATION_RAFFLES,
    })

    const typedEventsList = response.data.listUserVisitEvents.map(event => {
      const type = { type: EventTypes.VISIT_TO_CONSTRUCTION }
      return { ...event, type: EventTypes.VISIT_TO_CONSTRUCTION }
    })

    if (response) {
      await setGlobal({
        availableVisitationEvents: typedEventsList,
        shouldRefreshRaffles: false,
      })
    }
  } catch (e) {
    console.log('Error at list user events: ', e)
  }
}
